import React from "react";
import { useQuery } from "react-query";
import { IRecommendInquiry } from "@Types/business";
import { fetchMenuRecommendKind } from "@Services/inquiry";
import { InquiryItem } from "../../../pages/ask/re";
import { CloseFillIcon } from "@t8891/icon";
import { host } from "@Services/url";
import { useMount } from "ahooks";
import { Button, Mask } from "@t8891/pc";

export const Status_2_Result = ({ data, kindId }) => {
  return (
    <div
      className='w-[1190px] relative flex flex-col justify-center items-center py-70 bg-[#fff] mb-40'
      id='status-2-result'
    >
      <div className='flex flex-col items-center mb-60'>
        <img className='w-30 h-30' src='https://photo.8891.com.tw/2024/07/30/1722319909559963.png' />
        <div className='ml-14 mt-8 flex flex-col text-18 text-center leading-24 font-semibold text-[#333]'>
          徵求菜單提交成功
          <span className='text-14 text-[#666] text-center font-normal mt-8'>{data?.content}</span>
          <span className='text-14 text-[#666] text-center font-normal mt-8'>為您推薦其他詢價車款</span>
        </div>
      </div>

      <RecommendCarList kindId={kindId} />
    </div>
  );
};

export const Status_3_Result = ({ data }) => {
  return (
    <div
      className='w-[1190px] relative flex flex-col justify-center items-center py-70 bg-[#fff] mb-40'
      id='status-3-result'
    >
      <div className='flex flex-col items-center mb-16'>
        <CloseFillIcon size={30} fill='#ff4333' />
        <div className='ml-14 mt-8 flex flex-col text-18 text-center leading-24 font-semibold text-[#333]'>
          徵求菜單提交失敗
          <span className='text-14 text-[#666] text-center font-normal mt-8'>{data?.content}</span>
        </div>
      </div>

      <div className='w-[440px] h-[110px] bg-[#f0f5fd] flex relative flex-col items-center justify-center'>
        <div className='text-14 text-[#333] font-normal text-center mb-16'>
          現已有{data?.menuCount?.seek}位用戶發佈徵求菜單
        </div>
        <a
          target='_blank'
          id='result-3-btn'
          href={`${host.c}/agent/investment?globalSource=購車菜單`}
          className='bg-[#3264ff] text-[#fff] hover:text-[#fff] rounded-4 h-26 leading-[26px] px-14 text-center'
        >
          我是業代，獲客報價
        </a>
      </div>
    </div>
  );
};

export const Status_4_Result = ({ visible, content, onClose }) => {
  return (
    <Mask forceRender={true} visible={visible} center={true} style={{ "--z-index": "2002" }}>
      <>
        <div className='text-16 bg-white pd-30 rounded-8 text-center w-300 p-20'>
          <div
            className='text-16'
            style={{ display: "flex", justifyContent: "center", lineHeight: 1.4 }}
            dangerouslySetInnerHTML={{ __html: content?.replace(/\n/g, "<br/>") }}
          />
          <div className=''>
            <Button
              type='primary'
              size='middle'
              onClick={() => {
                onClose();
              }}
              className='mt-10'
              block
            >
              我知道了
            </Button>
          </div>
        </div>
      </>
    </Mask>
  );
};

const initData: IRecommendInquiry = {
  items: [],
  source: "",
  kindInfo: {
    kindId: 0,
    brandId: 0,
    brandName: "",
    kindName: "",
  },
};

const RecommendCarList: React.FC<{ kindId: string }> = ({ kindId }) => {
  const { data = initData } = useQuery<IRecommendInquiry>([`fetchMenuRecommendKind`], async () => {
    const res = await fetchMenuRecommendKind({ kindId, limit: 6 });
    return res?.status === 12000 ? res.data : initData;
  });

  const { items } = data;

  useMount(() => {
    window.inquirySource = "徵求菜單-詢價失敗-二次詢價";
  });

  if (!items?.length) return <></>;

  return (
    <div
      className='w-1120 h-294 mx-34 rounded-8'
      style={{ background: "linear-gradient(180deg,#fff0eb 0%, #ffffff 20%)" }}
    >
      <div className='text-18 flex items-center p-20 font-medium'>
        <div className='text-[#FF4433]'>90%</div>的用戶還詢價以下車款{" "}
        <div className='ml-8 text-14 flex items-center text-[#666] font-[400]'>無需2次填寫資料</div>{" "}
      </div>
      <div className='flex gap-30 px-4 justify-center'>
        {items?.map((item: any, index: number) => (
          <InquiryItem key={index} data={item} source='徵求菜單-詢價失敗-二次詢價' />
        ))}
      </div>
    </div>
  );
};
